<template>
  <section class="productHeader">
    <div class="productFoucs">
      <div class="image"
           :style="'background:url('+productImg+') #fff center center no-repeat;'"
           v-if="productImg"></div>
      <div class="image"
           :style="'background:url('+product.img+') #fff center center no-repeat;'"
           v-else></div>
      <div class="piclist">
        <div class="item"
             v-for="(item,index) in product.gallery"
             :key="index">
          <a href="javascript:;"
             :class="index==active?'active':''"
             @click="onPic(item,index)"
             :style="'background:url('+item+') #fff center center no-repeat;background-size:100%;'"></a>
        </div>
      </div>
    </div>
    <div class="productRight">
      <h2>{{product.title}}{{product.ptitle}}</h2>
      <div class="limitdtime">
        <div class="limitdLeft"><i class="el-icon-alarm-clock"></i>限时特惠</div>
        <div class="limitdRight">
          距离结束
          <span>{{day}}</span>: <span>{{hr}}</span>: <span>{{min}}</span>: <span>{{sec}}</span>
        </div>
      </div>
      <div class="productPrice">
        售价
        <span>
          ¥
          <span v-if="specs[0]">{{parseInt(product.price)+parseInt(specs[0].price)+parseInt(specs[1].price)}}</span>
        </span>
      </div>
      <div class="productSell">
        促销
        <span>环保补助金{{product.bonus_price}}元</span>
      </div>
      <div style="margin:50px"><img  src="https://image.suhuishou.com/attached/upload/20200831/20200831102555_5164.jpeg" width="150" height="150"/><p style="margin-top:50px">使用微信扫一扫 换新更便捷</p></div>
      <!--<div class="productSpecs">
        <div class="item"
             v-for="(item,index) in product.attr"
             :key="index">
          {{item.attr_name}}
          <span v-for="value in item.attr_value"
                :class="specs[index]&&specs[index]['value']==value.attr_value_id?'active':''"
                :key="value.attr_value_id"
                @click="onClick(value,index)"
                :data-value="value.attr_price">{{value.attr_value_name}}</span>
        </div>
      </div>
      <div class="productNum">
        <span>选择数量</span>
        <el-input-number v-model="number"
                         @change="handleChange"
                         :min="1"
                         :max="product.goods_number"
                         label="描述文字"></el-input-number>
      </div>
      <div class="beishu"
           :class="'beishu'+product.brand_id"></div> -->
    </div>
  </section>
</template>

<script>
export default {
  props: ["product", "specs"],
  data () {
    return {
      number: 1,
      productImg: "",
      active: 0,
      day: "07",
      hr: "24",
      min: "07",
      sec: "07",
      msec: 600000000
      // specs:[]
    };
  },
  methods: {
    handleChange (value) {
      if (value > this.product.goods_number) {
        this.$message({
          message: "超出库存.",
          type: "error"
        });
        return false;
      }
      this.$emit("changeNumber", value);
    },
    onClick (item, index) {
      let data = {
        value: item.attr_value_id,
        name: item.attr_value_name,
        price: item.attr_price
      };
      if (this.specs[index] === undefined) {
        this.specs.push(data);
      } else {
        this.specs.splice(index, 1, data);
      }
      this.$emit("changeSpecs", this.specs);
    },
    onPic (item, index) {
      this.active = index;
      this.productImg = item;
    },
    countdown: function () {
      // const end = new Date().setDate(new Date().getDate() + 5)
      // const now = Date.parse(new Date())
      const msec = this.msec;
      // const msec = (end - now)<0?0:end - now;
      let day = parseInt(msec / 1000 / 60 / 60 / 24);
      let hr = parseInt((msec / 1000 / 60 / 60) % 24);
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      this.day = day > 9 ? day : "0" + day;
      this.hr = hr > 9 ? hr : "0" + hr;
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      this.msec = this.msec - 1000;
      const that = this;
      setTimeout(function () {
        that.countdown();
      }, 1000);
    }
  },
  mounted () {
    this.countdown()
  }
};
</script>

<style scoped>
.productHeader {
  margin: 20px 0 0 0;
  display: flex;
}
.productFoucs .image {
  width: 320px;
  height: 400px;
  background-size: 300px !important;
}

.piclist {
  display: flex;
}
.piclist .item a {
  display: inline-block;
  width: 100px;
  height: 100px;
  margin: 12px 10px 0 0;
  border: solid #fff 1px;
}
.piclist .item a.active {
  border: solid #ff4747 1px;
}
.productRight {
  background: #fff;
  margin-left: 20px;
  width: 1110px;
  padding: 15px 20px 20px 20px;
}
.productRight h2 {
  font-size: 16px;
}
.productRight .limitdtime {
  display: flex;
  background: #f9415d;
  padding: 10px 20px 10px;
  color: #fff;
  margin: 15px -20px 0;
}
.productRight .limitdtime div {
  display: inline-block;
  width: 50%;
}
.productRight .limitdtime .limitdRight {
  text-align: right;
}
.productRight .limitdtime .limitdRight span {
  background: #333;
  color: #fff;
  display: inline-block;
  padding: 2px 5px;
  margin-right: 3px;
  border-radius: 2px;
}
.productRight .productPrice {
  background: #f5f5f5;
  padding: 10px 20px;
  margin: 0px -20px;
}
.productRight .productPrice > span {
  color: #e60012;
  margin-left: 50px;
}
.productRight .productPrice span span {
  font-size: 24px;
}
.productRight .productSell span {
  margin-left: 50px;
  color: #f0ae61;
}
.productRight .productSell {
  background: #f5f5f5;
  padding: 10px 20px;
  margin: 0px -20px;
}
.productRight .productSpecs {
  margin: 20px 0;
}
.productRight .productSpecs .item {
  margin-bottom: 20px;
}
.productRight .productSpecs .item span {
  display: inline-block;
  border: solid #cfcfcf 1px;
  padding: 5px 10px;
  margin-left: 15px;
  background: #f5f5f5;
  cursor: pointer;
}
.productRight .productSpecs .item span.active {
  border: solid #ff4747 1px;
}
.productNum span {
  margin-right: 20px;
}
.beishu {
  background: url(../../../assets/image/beishu.png) center center no-repeat;
  background-size: 552px 140px;
  width: 552px;
  height: 140px;
  margin: 20px auto 0;
}
.beishu13 {
  background: url(https://image.suhuishou.com/assets/image/oppo.png) center
    center no-repeat;
  background-size: 552px 140px;
}
.beishu3 {
  background: url(https://image.suhuishou.com/assets/image/mi.png) center center
    no-repeat;
  background-size: 552px 140px;
}
.beishu11 {
  background: url(https://image.suhuishou.com/assets/image/vivo.png) center
    center no-repeat;
  background-size: 552px 140px;
}
</style>
